import { render, staticRenderFns } from "./AssignRole.vue?vue&type=template&id=2bed19a0"
import script from "./AssignRole.vue?vue&type=script&lang=js"
export * from "./AssignRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports